
import React from 'react'
import styled from 'styled-components'
import { getExchangeNFTs2Address } from '../../sushi/exchangeNFTs'
import useYam from '../../hooks/bakery/useYam'

const Falg = styled.div`
  position: absolute;
  top: 0px;
  left: 8px;
  z-index: 1;
  img {
    width: 30px;
  }
`

export default function LevelFlagStatus ({artwork, ids}: {artwork: any, ids: any}) {
  const sushi = useYam()
  const exchangeNfts2Address = getExchangeNFTs2Address(sushi)
  const Flag = () => {
    if (!artwork) return null
    if (artwork.nftLevel === 'v1') return null

    if (!(+artwork.price) && !ids.includes(artwork.tokenId)) return null

    if (artwork.exchangeAddress?.toLocaleLowerCase() === exchangeNfts2Address.toLocaleLowerCase()) {
      return (
        <Falg>
          <img src='/images/nft/v3.png' alt=""/>
        </Falg>
      )
    }

    if (artwork.exchangeAddress?.toLocaleLowerCase() !== exchangeNfts2Address.toLocaleLowerCase()) {
      return (
        <Falg>
          <img src='/images/nft/v2.png' alt=""/>
        </Falg>
      )
    }

    return null
  }
  return <Flag />
}